import { get, post, put, destroy } from 'api';
import config from 'config';

import Department from '../models/department';
import DepartmentRequest from '../models/department-request';
import { UserDepartmentSettings } from '../models/user-department-settings';

const dealerUrl = config.get('api.dealer');
export interface LinkFacebookPageRequest {
  dealerId: number;
  departmentId: number;
  locationId: number;
  facebookPageId: string;
  crmUserId: string;
}

export interface LinkFacebookAccountRequest {
  dealerId: number;
  locationId: number;
  userAccessToken: string;
  facebookUserId: number;     
  facebookEmail: string;
  facebookUserName: string;
  crmUserId: string;
}

export interface FacebookPageInfo {
  id: string;
  name: string;
  category: string;
  pictureUrl: string;
  isConnected: boolean;
  // Instagram fields
  instagramBusinessAccountId?: string;
  instagramUsername?: string;
  instagramProfilePictureUrl?: string;
  hasInstagramAccount?: boolean;
}

export interface GetFacebookPagesRequest{
  locationId: number;
  departmentId: number;
}
export interface UpdateFbBannerRequest{
  fbAccountIds:number[];
}

export interface expiryFacebookAccounts {
  facebookAccountId: number;
  locationId: string;
  locationName: string;
}

const DepartmentAPI = {
  async getDepartments(selectedDealerLocationId: number, dmsDealerIdCrm: number): Promise<Department[]> {
    const url = `${dealerUrl}/dealers/${dmsDealerIdCrm}/departments?dealerId=${selectedDealerLocationId}`;
    const { data } = await get(url);
    return data;
  },
  async getDepartment(dmsDealerIdCrm: number, id: number): Promise<any> {
    const url = `${dealerUrl}/dealers/${dmsDealerIdCrm}/departments/${id}`;
    const { data } = await get(url);
    return data;
  },
  async createDepartment(
    dmsDealerIdCrm: number,
    departmentName: string,
    dealerLocationId: number,
    crmUserIds: number[],
  ): Promise<Department> {
    const url = `${dealerUrl}/dealers/${dmsDealerIdCrm}/departments`;
    const requestBody: DepartmentRequest = {
      departmentName,
      dealerId: dealerLocationId,
      crmUserIds,
    };
    const { data } = await post(url, requestBody);
    return data;
  },
  async updateDepartment(
    dmsDealerIdCrm: number,
    departmentId: number,
    departmentName: string,
    crmUserIds: number[],
    dealerLocationId: number,
  ): Promise<any> {
    const url = `${dealerUrl}/dealers/${dmsDealerIdCrm}/departments/${departmentId}`;
    const updateDepartmentRequest = {
      crmUserIds,
      departmentId,
      departmentName,
      dealerId: dealerLocationId,
    };
    const { data } = await put(url, updateDepartmentRequest);
    return data;
  },
  async deleteDepartment(dmsDealerIdCrm: number, id: number): Promise<any> {
    const url = `${dealerUrl}/dealers/${dmsDealerIdCrm}/departments/${id}`;
    const { data } = await destroy(url);
    return data;
  },
  async getUserDepartmentSetting(dmsDealerIdCrm: number, crmUserId: string): Promise<UserDepartmentSettings> {
    const url = `${dealerUrl}/v2/dealers/${dmsDealerIdCrm}/users/${crmUserId}/departments`;
    const { data } = await get(url);
    return data;
  },
  async updateUserDepartmentSettings(
    dmsDealerIdCrm: number,
    crmUserId: string,
    departmentIds: number[],
  ): Promise<UserDepartmentSettings> {
    const url = `${dealerUrl}/v2/dealers/${dmsDealerIdCrm}/users/${crmUserId}/departments`;
    const { data } = await post(url, { crmUserId, UserSelectedDepartments: departmentIds });
    return data;
  },
  async updateDealerFacebookTokens(facebookSettingsRequest:any): Promise<UserDepartmentSettings> {
    const url = `${dealerUrl}/dealers/UpdateDealerFacebookTokens`;    
    const { data } = await post(url, facebookSettingsRequest );
    return data;
  },
   async linkFacebookPage(linkFacebookPageRequest:LinkFacebookPageRequest): Promise<boolean> {
    const url = `${dealerUrl}/dealers/LinkFacebookPage`;    
    const { data } = await post(url, linkFacebookPageRequest );
    return data;
  },
   async linkFacebookAccount(linkFacebookAccountRequest:LinkFacebookAccountRequest): Promise<boolean> {
    const url = `${dealerUrl}/dealers/LinkFacebookAccount`;    
    const { data } = await post(url, linkFacebookAccountRequest );
    return data;
  },

  async getFacebookPages(pagesReq:GetFacebookPagesRequest): Promise<FacebookPageInfo[]> {
    const url = `${dealerUrl}/dealers/GetFacebookPages`;    
    const { data } = await post(url, pagesReq);
    return data;
  },

  async isFacebookAccountLinked(locationId:number): Promise<boolean> {
    const url = `${dealerUrl}/dealers/IsFacebookAccountLinked/${locationId}`;    
    const { data } = await get(url);
    return data;
  },
  async getExpiryFacebookAccounts(): Promise<expiryFacebookAccounts[]> {
    const url = `${dealerUrl}/dealers/GetExpiryFacebookAccounts`;    
    const { data } = await get(url);
    return data;
  },
   async UpdateFacebookAccountBanner(request: UpdateFbBannerRequest): Promise<expiryFacebookAccounts[]> {
    const url = `${dealerUrl}/dealers/UpdateFacebookAccountBanner`;    
    const { data } = await put(url, request);
    return data;
  },

};

export default DepartmentAPI;
